import React, { memo, useMemo } from 'react';
import { createUseStyles, Text } from 'hoi-poi-ui';
import Image from "./components/Image";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'Generic error');
const Error = _ref => {
  let {
    logo,
    title,
    description,
    image: ImageProp
  } = _ref;
  const classes = useStyles();
  const ImageComponent = useMemo(() => ImageProp || Image, [ImageProp]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.canvas
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logo
  }, logo), /*#__PURE__*/React.createElement(Text, {
    type: "h6",
    className: classes.title
  }, title), description && /*#__PURE__*/React.createElement(Text, {
    type: "body",
    className: classes.description
  }, description), /*#__PURE__*/React.createElement(ImageComponent, {
    className: classes.image
  })));
};
export default /*#__PURE__*/memo(Error);